import GenericMessage from './GenericMessage';
import styles from './successMessage.module.less';

const SuccessMessage = ({ children, className = '', hideIcon = false }) => (
    <GenericMessage
        icon="checkmark"
        iconStyle={styles.icon}
        iconContainerClass={hideIcon ? styles.hideIcon : ''}
        containerStyle={hideIcon ? styles.messageContainerWithoutIcon : styles.messageContainer}
        textStyle={styles.text}
        className={className}
    >
        {children}
    </GenericMessage>
);

export default SuccessMessage;
